import BABYNAME_CONFIGS from './babynameRaw'
import { COLORS } from '../utils/styles'
import COUNTRY_LIST from '../statics/configs/babynameCountryList.json'
import routes from './routes'

export const SEX_CONFIGS = {
  M: {
    title: 'Boy',
    slug: BABYNAME_CONFIGS.SEX_CONFIGS['M'].slug,
    backgroundColor: COLORS.VERY_LIGHT_BLUE,
    hoverBackgroundColor: COLORS.PASTEL_BLUE,
    nameButton: {
      defaultStateColor: COLORS.VERY_LIGHT_BLUE,
      activeStateColor: COLORS.BLUE_TALE,
    },
  },
  F: {
    title: 'Girl',
    slug: BABYNAME_CONFIGS.SEX_CONFIGS['F'].slug,
    backgroundColor: COLORS.PALE_MAUVE,
    hoverBackgroundColor: COLORS.POWDER_PINK,
    nameButton: {
      defaultStateColor: COLORS.PALE_MAUVE,
      activeStateColor: COLORS.VERY_LIGHT_PINK,
    },
  },
}

export const ALPHABET = BABYNAME_CONFIGS.ALPHABET

export const searchURL = (text, isBoy, isGirl, isNeutral, isSearchByName = true) => {
  if (isSearchByName || isNeutral) {
    // this is intention to make double encode for name
    // because `history` from `react-router-dom` always decode behind-the-scene
    const encodedText = encodeURIComponent(encodeURIComponent(text))
    const sex = isBoy && !isGirl ? 'sex=boy' : !isBoy && isGirl ? 'sex=girl' : ''
    const neutral = isNeutral ? 'neutral=true' : ''
    const param = sex && neutral ? `${sex}&${neutral}` : `${sex}${neutral}`
    return routes.babyNameSearch.pathResolver(`${encodedText}${param ? `?${param}` : ''}`)
  } else {
    const sex = isBoy && !isGirl ? 'boy' : !isBoy && isGirl ? 'girl' : ''
    return routes.babyNameAlphabetList.pathResolver(text, sex)
  }
}

export const getSexConfigBySlug = sex => {
  return Object.entries(SEX_CONFIGS).find(([, value]) => value.slug === sex)
}

export const ALPHABET_IMAGE = alphabet => {
  const IMAGE = require(`../statics/images/babyname/alphabet/BNW_Alphabet_${alphabet}.jpg`)
  return IMAGE
}

export const getCountry = countryCode => {
  return COUNTRY_LIST.find(element => element?.country?.alpha3 === countryCode.toUpperCase())
}

export const getState = (countryCode, stateCode) => {
  const country = getCountry(countryCode)?.states
  return country.find(element => element?.state?.code === stateCode.toUpperCase())
}
